/**
 * Grabs the data we dump from the server into the DOM and exports them as a singleton.
 * This allows us to conveniently dump server data into the dom and use this to load
 * that data into our app.
 */
// because the way webpack is implemented, you can import this file anywhere
// in the codebase like so:
// import serverData from 'utils/server-data'
// @ts-ignore
import { WorldReady } from '@paypalcorp/worldready'
import { AppDownloadContentProps } from '../types/app-download'
import { DeviceDetails } from '../types/device-details'
import { initRum } from 'lib/rum-init'
import { DatadogSite } from 'types/common'

export type NonPIIQueryParams = {
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_content?: string
  utm_unptid?: string
  utm_term?: string
  sfmc_id?: string
  internal_user?: string
  unptid?: string
  ref_tsrce?: string
  tsrce?: string
  source?: string
  pp_ref_id?: string
  cust?: string
  src?: string
  xe?: string
  xt?: string
}

export type ServerDataShape = {
  _csrf: string
  nonce: string
  cdnHost?: string
  requestURI?: string
  fraudnetSrc?: string
  calId?: string
  ppRefId: string
  ppRef: string
  nonPiiQueryParams?: NonPIIQueryParams
  locality?: {
    country: string
    locale: string
    reqLocale: string
  }
  worldReady?: Record<any, any>
  content: AppDownloadContentProps
  isLoggedIn: boolean
  deviceDetails: DeviceDetails
  bodyClass?: string
  flags?: {
    hideHeaderFooter?: boolean
  }
  navigation?: {
    header: {
      bodyHtml?: string
      headHtml?: string
      sys?: unknown
    }
    footer?: {
      bodyHtml?: string
      headHtml?: string
      sys?: unknown
    }
  }
  datadog: {
    applicationId: string
    clientToken: string
    site: DatadogSite
  }
  env?: string
  elmoTracking: {
    xe?: string
    xt?: string
  }
}

const serverData = {} as ServerDataShape

const init = () => {
  const dataNode = document.getElementById('server-data')

  if (!dataNode) {
    console.error('There was no element with the id of server-data.')
    return
  }

  try {
    const serverDataString = dataNode.innerHTML
    Object.assign(serverData, JSON.parse(serverDataString))

    if (dataNode.parentElement) {
      dataNode.parentElement.removeChild(dataNode) // cleanup the DOM
    }

    if (process.env.NODE_ENV !== 'test') {
      // paypal-scripts will load worldReady with content automatically during tests
      WorldReady.load(serverData.worldReady)
    }
    // Initialize Datadog RUM
    initRum(serverData)
  } catch (err) {
    console.error('server-data: load', err)
  }
}

export default serverData
export { init }
/* eslint no-console:0 */
